/* unplugin-vue-components disabled */import { render } from "./simple-header.vue?vue&type=template&id=b0521322&scoped=true&ts=true"
import script from "./simple-header.vue?vue&type=script&lang=ts"
export * from "./simple-header.vue?vue&type=script&lang=ts"

import "./simple-header.vue?vue&type=style&index=0&id=b0521322&lang=less&scoped=true"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0521322"]])

export default __exports__